import React from "react"
import Header from "./header"
import Menu from "./menu"
import Footer from "./footer"
import CTABar from "./cta-bar"
import { shapeBrand } from "../utils/gradi"
import Geocode from "react-geocode"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from 'gatsby';
import { SEOContext } from 'gatsby-plugin-wpgraphql-seo';

import "../assets/style.css"

const Layout = ({ currentBrand, children, unpadded = false, location }) => {
  /*
  Geocode.setApiKey("AIzaSyCu2dCQwQwtfIswp6Z9e7QwH-XzxyC7vac");
  Geocode.setLanguage("en");

   navigator.geolocation.getCurrentPosition(function(position) {
      console.log("Latitude is :", position.coords.latitude);
      console.log("Longitude is :", position.coords.longitude);
      Geocode.fromLatLng(position.coords.latitude, position.coords.longitude).then(
        response => {
          const address = response.results[0].formatted_address;
          console.log(address);
        },
        error => {
          console.error(error);
        }
      );
    });
  */

  const layoutClasses = unpadded ? "" : " mx-auto px-2 md:px-10"

  let defaultBrand = { path: '/400', brand: 'gradi',name: '400', menuLinks: []}

  let brand = currentBrand
  if (brand === null || brand === undefined) {
    brand = defaultBrand
  }

  const path = typeof window !== "undefined" ? window.location.pathname : ""
  const isHome = path === brand.path

  const brandTitles = {
    gradi: "400 Gradi",
    "400": "400 Gradi",
    zero: "Zero Gradi",
    mercato: "Mercato",
    pronto: "Gradi Pronto",
  }
  const title = brandTitles[brand.name] || brand.name
    const {
        wp: { seo },
      site: { siteMetadata: { siteLocale } },
    } = useStaticQuery(graphql`
        query SiteInfoQuery {
            site {
              siteMetadata {
                siteLocale
              }
            }
            wp {
                seo {
                    contentTypes {
                        post {
                            title
                            schemaType
                            metaRobotsNoindex
                            metaDesc
                        }
                        page {
                            metaDesc
                            metaRobotsNoindex
                            schemaType
                            title
                        }
                    }
                    webmaster {
                        googleVerify
                        yandexVerify
                        msVerify
                        baiduVerify
                    }
                    schema {
                        companyName
                        personName
                        companyOrPerson
                        wordpressSiteName
                        siteUrl
                        siteName
                        inLanguage
                        logo {
                            sourceUrl
                            mediaItemUrl
                            altText
                        }
                    }
                    social {
                        facebook {
                            url
                            defaultImage {
                                sourceUrl
                                mediaItemUrl
                            }
                        }
                        instagram {
                            url
                        }
                        linkedIn {
                            url
                        }
                        mySpace {
                            url
                        }
                        pinterest {
                            url
                            metaTag
                        }
                        twitter {
                            username
                        }
                        wikipedia {
                            url
                        }
                        youTube {
                            url
                        }
                    }
                }
            }
        }
    `);


  return (
    <SEOContext.Provider value={{ global: seo, options: { schemaReplacement: { from:'admin.400gradi.com.au', to: '400gradi.com.au' }}}}>
    <div className={`${brand.name} min-h-screen bg-page`}>
      <Helmet>
        <meta
          name="facebook-domain-verification"
          content="br82rgq53xara6jlzaxpyyhdwtydzz"
        />
        <title>{title}</title>
        {process.env.GATSBY_GSITE_VERIFICATION && (
          <meta
            name="google-site-verification"
            content={process.env.GATSBY_GSITE_VERIFICATION}
          />
        )}

        {process.env.GATSBY_FACEBOOK_VERIFICATION && (
          <meta
            name="facebook-domain-verification"
            content={process.env.GATSBY_FACEBOOK_VERIFICATION}
          />
        )}
        { location?.href && <link rel="canonical" href={location.href} />}
        { location?.href && <link rel="alternate" href={location.href} hreflang={siteLocale} />}

       </Helmet> 
      
        <CTABar currentBrand={brand} />
      <Header currentBrand={brand} isHome={isHome} />
      <div
        className={`${layoutClasses} 2xl:mx-auto 2xl:container 2xl:px-10 pb-10 gap-5`}
      >
        {children}
      </div>
      <Footer currentBrand={brand} />
    </div>
    </SEOContext.Provider>
  )
}

export default Layout
